import { observer } from "mobx-react-lite";
import React from "react";
import { Flags } from "../../generated/FeatureFlags";
import { featureFlagsStorage } from "../../services/feature-flags/FeatureFlagsStorage";
import Language from "../../services/translation/language";
import { translationService } from "../../services/translation/TranslationService";
import { Dropdown, DropdownOption } from "../dropdown/Dropdown";

export default observer(function LanguageSelector() {
    const languageOptions: Array<DropdownOption> = [];
    Object.keys(Language).forEach((lang) => {
        if (lang === Language.keys && !featureFlagsStorage.isFeatureEnabled(Flags.Show_Translation_Keys_Option_In_Language_Dropdown)) return;
        languageOptions.push({
            id: (Language as any)[lang],
            name: (Language as any)[lang].toUpperCase(),
        });
    });

    return (
        <div className="navbar-dropdown-language">
            <Dropdown
                options={languageOptions}
                selectedOption={{
                    id: translationService.language,
                    name: translationService.language.toUpperCase(),
                }}
                onChange={(newLanguage: DropdownOption) => {
                    translationService.changeLanguage(newLanguage.id.toString() as Language);
                }}
                onDarkBackground
            />
        </div>
    )
})